import React, { Component, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCandidateApps, getFilterCandidates, loadCandidateApps, loadCandidatesByFilter } from "../../app/store/candidate";
import { useDispatch, useSelector } from "react-redux";
import { getFieldData, getFormatedNumber } from "../../services/appService";
import CandidateInfo from "../../app/components/CandidateInfo";
import Subcontractor from "../../app/components/Invoices/Subcontractor";
import Recruiter from "../../app/components/Invoices/Recruiter";
import Agency from "../../app/components/Invoices/Agency";
import { getAllRates, loadAllRates } from "../../app/store/rates";

export default function CadidateDetails(props) {

  const { type } = props;

  let pgTitle = "Time Log Management";
  if (type === "invoice")
    pgTitle = "Invoics and Payments";

  const route = [
    { name: "Onboarding and Contracts", url: "" },
    {
      name: "Candidates",
      url: "/ListCondidate/" + type,
    },
    {
      name: "Working Hub",
      url: "/ListCondidate/" + type,
    }];

  const [selectedItem, setSelectedItem] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [candidateObj, setCandidateObj] = useState("");
  const [tableShowHide, setTableShowHide] = useState(false);
  const [wfTask, setWfTask] = useState(null);
  const [candidateApps, setCandidateApps] = useState(null);
  const [allRates, setAllRates] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const candidatesSelector = useSelector(getFilterCandidates);
  const candidateAppsSelector = useSelector(getCandidateApps);
  const allRatesSelector = useSelector(getAllRates);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const state = location.state;
    if (state?.item) {
      setSelectedItem(state.item);
      getCandidateDetails(state.item.id || state.item.performerid)
      dispatch(loadAllRates(state.item?.performerid));
    }
    if (state?.type) {
      setSelectedType(state.type);
    }
  }, [location.state?.item?.id || location.state?.item?.performerid, location.state?.type]);

  const getCandidateDetails = async (candidateId) => {
    const frmBody = new FormData();
    frmBody.append("id", candidateId || "");
    frmBody.append("name", "");
    frmBody.append("email", "");
    frmBody.append("entity", "");
    frmBody.append("type", "candidate");
    frmBody.append("filterType", "single");
    dispatch(loadCandidatesByFilter(frmBody));
  };

  useEffect(() => {
    const reqId = location.state?.item?.id || location.state?.item?.performerid;
    if (candidatesSelector.length > 0 && reqId) {
      const candidate = candidatesSelector[0];
      if (candidate.id === reqId || candidate.performerid === reqId) {
        setCandidateObj(candidate);
        const apps = candidate.applications;
        if (apps.length > 0) {
          setCandidateApps(apps[0]);
          dispatch(loadCandidateApps(apps[0].applicantId, "admin", 1, apps[0].ciid));
        }
      } else {
        setCandidateObj("");
        setCandidateApps(null);
        setWfTask(null);
      }
    } else {
      setCandidateObj("");
      setCandidateApps(null);
      setWfTask(null);
    }
  }, [candidatesSelector, location.state]);

  useEffect(() => {
    if (candidateAppsSelector.length > 0) {
      const latestApp = candidateAppsSelector[0];

      let wfTasks = latestApp.workflowTasks.filter(
        (x) => x.itemType === 1 && x.wiid > 0 && x.taskDoneStatus === 2 //&& x.formType === "WF"
      ).sort((a, b) => a.orderNumber - b.orderNumber);

      if (wfTasks.length === 0) {
        wfTasks = latestApp.workflowTasks.filter(
          (x) => x.itemType === 1 && x.wiid > 0 && x.taskDoneStatus === 4 //&& x.formType === "WF"
        ).sort((a, b) => b.orderNumber - a.orderNumber);
      }
      const latestTask = wfTasks[0];
      setWfTask(latestTask);

    }
  }, [candidateAppsSelector])

  useEffect(() => {
    setAllRates(allRatesSelector);
  }, [allRatesSelector])

  useEffect(() => {
    if (candidateObj !== "") {
      setActiveTab(0);
    }
  }, [candidateObj, selectedType]);

  let item = candidateObj || selectedItem;
  let entType = "";
  const ptype = selectedType;
  if (item) {
    const perfData = item?.performerData;
    entType = getFieldData(
      perfData,
      "candidateonboardingform",
      "CandidateEntity"
    );
  }

  const handleSectionHideShow = (data) => {
    setTableShowHide(data)
  }

  return (
    <React.Fragment>
      <style>{`
        /* Premium Tabs Styling (Matching WorkflowUser Tabs) */
        .candidate-details-container {
          padding-top: 15px !important;
          padding-bottom: 30px !important;
          padding-left: 0px !important;
          padding-right: 0px !important;
          font-family: "Open Sans", sans-serif !important;
          font-size: 14px !important;
          color: #1e293b !important;
        }

        .wf-tab-bar {
          display: flex !important;
          align-items: stretch !important;
          gap: 4px !important;
          border-bottom: 2px solid #e5e5e5 !important;
          margin-bottom: 0 !important;
          padding: 8px 0 0 !important;
          position: relative !important;
          flex: 0 0 auto !important;
        }

        .wf-tab-btn {
          position: relative !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          border: none !important;
          background: transparent !important;
          padding: 9px 16px 11px !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          font-family: "Open Sans", sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          border-radius: 0 !important;
          transition: color 0.2s ease, background 0.2s ease !important;
          outline: none !important;
          white-space: nowrap !important;
        }

        .wf-tab-btn i {
          font-size: 14px !important;
          color: currentColor !important;
          transition: color 0.2s ease !important;
        }

        .wf-tab-btn:hover {
          color: #0f172a !important;
          background: #f5f5f5 !important;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #ffffff !important;
          font-weight: 500 !important;
          background: #171717 !important;
        }

        .wf-tab-btn.active i {
          color: #ffffff !important;
        }

        .wf-tab-btn::after {
          content: "" !important;
          position: absolute !important;
          bottom: -2px !important;
          left: 0 !important;
          right: 0 !important;
          height: 2px !important;
          background: #171717 !important;
          border-radius: 0 !important;
          transform: scaleX(0) !important;
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        .wf-tab-btn.active::after {
          transform: scaleX(0) !important;
        }

        .wf-tab-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          min-width: 20px !important;
          height: 20px !important;
          padding: 0 6px !important;
          border-radius: 0 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          background: #f1f5f9 !important;
          color: #1e293b !important;
          border: 1px solid #e2e8f0 !important;
          transition: all 0.2s ease !important;
          line-height: 1 !important;
        }

        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff !important;
          color: #171717 !important;
          border-color: #ffffff !important;
        }

        /* Tab content panels */
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          padding: 24px !important;
          margin-top: 16px !important;
          box-shadow: 0 4px 16px rgba(15, 23, 42, 0.03) !important;
          font-family: "Open Sans", sans-serif !important;
          font-size: 14px !important;
          color: #1e293b !important;
        }

        .back-btn-container {
          display: flex !important;
          justify-content: flex-end !important;
          margin-bottom: 15px !important;
        }

        .back-btn-modern {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          color: #1e293b !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          font-family: "Open Sans", sans-serif !important;
          letter-spacing: 0.01em !important;
          line-height: 1.25 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          cursor: pointer !important;
          outline: none !important;
          min-height: unset !important;
        }

        .back-btn-modern:hover {
          background: #f8fafc !important;
          border-color: #94a3b8 !important;
          color: #0f172a !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        .back-btn-modern i {
          font-size: 14px !important;
          color: inherit !important;
          transition: transform 0.15s ease !important;
        }

        .back-btn-modern:hover i {
          transform: translateX(-2px) !important;
        }
      `}</style>

      <div className="candidate-details-container">
        {item && (
          <>
            <div className="form-group mb-4">
              <CandidateInfo
                candidate={item}
                handleSectionHideShow={handleSectionHideShow}
                type={"candetails"}
                app={candidateApps}
                listType={ptype}
                candidateListState={location.state?.candidateListState}
              />
            </div>

            <div className="candidate-details-tabs">
              {/* Custom Tab Bar */}
              <div className="wf-tab-bar">
                <button
                  className={`wf-tab-btn${activeTab === 0 ? " active" : ""}`}
                  onClick={() => setActiveTab(0)}
                >
                  <i className="fa fa-clock-o" />
                  {ptype === "invoice" && entType === "C2C Basis"
                    ? "Subcontractor"
                    : "Time Log"}
                </button>
                {ptype === "invoice" && (
                  <button
                    className={`wf-tab-btn${activeTab === 1 ? " active" : ""}`}
                    onClick={() => setActiveTab(1)}
                  >
                    <i className="fa fa-user-circle-o" />
                    Recruiter
                  </button>
                )}
                {ptype === "invoice" && (
                  <button
                    className={`wf-tab-btn${activeTab === 2 ? " active" : ""}`}
                    onClick={() => setActiveTab(2)}
                  >
                    <i className="fa fa-building-o" />
                    Agency/Client
                  </button>
                )}
              </div>

              {/* Custom Tab Panels */}
              {activeTab === 0 && (
                <div className="wf-tab-panel">
                  <Subcontractor candidate={item} allRates={allRates} ptype={ptype} entType={entType} wfTask={wfTask} />
                </div>
              )}
              {activeTab === 1 && ptype === "invoice" && item.recruiter && (
                <div className="wf-tab-panel">
                  <Recruiter candidate={item} allRates={allRates} ptype={ptype} entType={entType} wfTask={wfTask} />
                </div>
              )}
              {activeTab === 2 && ptype === "invoice" && (
                <div className="wf-tab-panel">
                  <Agency candidate={item} allRates={allRates} ptype={ptype} entType={entType} wfTask={wfTask} />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </React.Fragment>
  );
}
